import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'idUppercase' })
export class IDUpperCasePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return value.replace(/Id /g, "ID ");
    }
}